import getCalendarFoldersService from '../services/getCalendaFoldersService';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import { initializeAgendaMailOption } from '../actions/publicActions';
import {
    loadCalendarFoldersToStore,
    setGetCalendarFolderServiceStatus,
    setAgendaMailEnabled,
} from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import RequestStatus from '../store/schema/RequestStatus';

export default orchestrator(initializeAgendaMailOption, async () => {
    // Reads from mailboxCalendarConfiguration.AgendaMailEnabled and set it in option store
    const mailboxCalendarConfiguration = getCalendarConfiguration();
    if (mailboxCalendarConfiguration) {
        setAgendaMailEnabled(mailboxCalendarConfiguration.AgendaMailEnabled);
    }

    // Load the calendar folders from server
    setGetCalendarFolderServiceStatus(RequestStatus.Pending);
    const getCalendarFolderResponse = await getCalendarFoldersService();
    if (!getCalendarFolderResponse.WasSuccessful) {
        setGetCalendarFolderServiceStatus(RequestStatus.Error);
    } else {
        setGetCalendarFolderServiceStatus(RequestStatus.Completed);
    }

    // Set the server calendar folders in the agenda mail options store
    loadCalendarFoldersToStore(getCalendarFolderResponse.CalendarFolders);
});
